import { render, staticRenderFns } from "./RDAComponentCompetence.vue?vue&type=template&id=455abfd2&scoped=true"
import script from "./RDAComponentCompetence.vue?vue&type=script&lang=js"
export * from "./RDAComponentCompetence.vue?vue&type=script&lang=js"
import style0 from "./RDAComponentCompetence.vue?vue&type=style&index=0&id=455abfd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455abfd2",
  null
  
)

export default component.exports